import React, { Fragment, useState, useRef, useEffect } from "react";
import { Alert, Button, Col, FormGroup, Input, Label, Media, Row } from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { checkTitle } from "../../store/prodcutSlice";
import { useDispatch } from "react-redux";
import { getCurrencyRate } from "../../store/lookBookSlice";
import PreLoader from "../../../../share-components/ui/preLoader";
import moment from "moment";
import Switch from "react-switch";

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
  }),
};
const holidayOfferFrom = (props) => {
  const {
    errors,
    control,
    register,
    setValue,
    trigger,
    roles,
    getValues,
    setIsActiveMode,
    productState,
    isActiveModeLoading,
    onDownloadActiveOrders,
    exportingActiveOrders,
    authData
  } = props;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const ref = useRef(null);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const dispatch = useDispatch();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [offerDate, setOfferDate] = useState(null);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [isActivate, setIsActivate] = useState(false);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const handleChange = (nextChecked1) => {
    nextChecked1 ? setValue("is_active", true) : setValue("is_active", false);
    setIsActivate(nextChecked1);
    setIsActiveMode(nextChecked1);
  };

  return (
    <Fragment>
      <FormGroup>
        <Label className="form-label">Active Holiday Mode</Label>
        <div className="form-control pl-0 border-0">
          <Switch uncheckedIcon={false} checkedIcon={false} onChange={handleChange} checked={isActivate} className="react-switch" />
        </div>
        <div style={{ width: "100%", marginTop: "0.25rem", fontSize: "80%", color: "#dc3545" }}>{errors.isPremium?.message}</div>
      </FormGroup>
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          minHeight: 50,
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {productState.holidayOrders.is_having_orders && (
          <div>
            <Alert
              className="d-flex align-items-center justify-content-between"
              style={{
                color: "#842029",
                backgroundColor: "#f8d7da",
                borderColor: "#f5c2c7",
              }}
            >
              <div className="d-flex align-items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                  viewBox="0 0 16 16"
                  role="img"
                  aria-label="Warning:"
                >
                  <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                </svg>
                <div className="ms-1 ml-1">
                  Some of your selected products are part of active orders. Please fulfill them before activating holiday mode.{" "}
                  <span>
                    <a
                      onClick={() => onDownloadActiveOrders(productState)}
                      className="mr-2"
                      style={{textDecoration : "underline", color : "#6a1a21", fontWeight:500, cursor : "pointer"}}
                      disabled={!productState.holidayOrders.is_having_orders || exportingActiveOrders}
                    >
                      Download your unfulfilled order list
                    </a>
                  </span>
                </div>
              </div>
            </Alert>
          </div>
        )}

        {isActiveModeLoading && !productState.holidayOrders.is_having_orders && (
          <div className="card-loading">
            <i className="fa fa-spinner fa-lg spinner" style={{ fontSize: "2rem" }} />
          </div>
        )}

        {(isActivate && !isActiveModeLoading && !exportingActiveOrders) && (
          <div className="form-row" style={{ marginLeft: "20px" }}>
            <Col md="6">
              <FormGroup>
                <Label className="col-form-label">Offer Date</Label>
                <div style={{ display: "flex" }}>
                  <div className="checkbox checkbox-dark">
                    <Input
                      id="is_end_date"
                      type="checkbox"
                      onChange={(e) => {
                        setValue("is_end_date", e.target.checked);
                        setValue("end_date", null);
                        setValue("no_of_days", "");

                        // trigger('end_date');
                        trigger("is_end_date");
                      }}
                      defaultChecked={getValues("is_end_date")}
                    />
                    <Label for="is_end_date"></Label>
                  </div>
                  <DatePicker
                    name="dispatchDate"
                    className={`form-control digits ${errors.end_date ? "is-invalid" : ""}`}
                    selected={getValues("end_date") ? new Date(getValues("end_date")) : null}
                    onChange={(date) => {
                      setValue("end_date", date);
                      trigger("end_date");
                    }}
                    minDate={moment().toDate()}
                    readOnly={!getValues("is_end_date")}
                    style={{ minHeight: "auto" }}
                    dateFormat="dd-MM-yyyy"
                  />
                </div>
                <div className="invalid-feedback">{errors.end_date?.message}</div>
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <Label className="col-form-label">No Of Days</Label>
                <input
                  disabled={getValues("is_end_date")}
                  name="no_of_days"
                  type="number"
                  {...register("no_of_days")}
                  className={`form-control ${errors.no_of_days ? "is-invalid" : ""}`}
                />
                <div className="invalid-feedback">{errors.no_of_days?.message}</div>
              </FormGroup>
            </Col>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default holidayOfferFrom;
